import { __async } from '../chunk-YSKSG3AS.mjs';
import { ConnectorNotFoundError, SwitchChainNotSupportedError } from 'wagmi';
import { InjectedConnector } from 'wagmi/connectors/injected';
import '@wagmi/core/window';
import { UserRejectedRequestError, ResourceUnavailableRpcError, getAddress } from 'viem';

var mappingNetwork = {
  5e3: {
    name: "mantle-mainnet",
    rpcUrl: "https://rpc.mantle.xyz"
  },
  5003: {
    name: "mantle-sepolia",
    rpcUrl: "https://rpc.sepolia.mantle.xyz"
  }
};
function getBitgetWalletProvider() {
  var _a;
  return (_a = window == null ? void 0 : window.bitkeep) == null ? void 0 : _a.ethereum;
}
var BitgetWalletConnector = class extends InjectedConnector {
  constructor({
    chains: _chains,
    options: _options
  } = {}) {
    var _a, _b;
    const options = {
      name: "Bitget Wallet",
      shimDisconnect: (_a = _options == null ? void 0 : _options.shimDisconnect) != null ? _a : false,
      shimChainChangedDisconnect: (_b = _options == null ? void 0 : _options.shimChainChangedDisconnect) != null ? _b : true
    };
    const chains = _chains == null ? void 0 : _chains.filter((c) => !!mappingNetwork[c.id]);
    super({
      chains,
      options
    });
    this.id = "Bitkeep";
  }
  connect() {
    return __async(this, arguments, function* ({ chainId } = {}) {
      var _a;
      try {
        const provider = yield this.getProvider();
        if (!provider) {
          throw new ConnectorNotFoundError();
        }
        if (provider.on) {
          provider.on("accountsChanged", this.onAccountsChanged);
          provider.on("chainChanged", this.onChainChanged);
          provider.on("disconnect", this.onDisconnect);
        }
        this.emit("message", { type: "connecting" });
        const account = yield this.getAccount();
        let id = yield this.getChainId();
        let unsupported = this.isChainUnsupported(id);
        if (chainId && id !== chainId) {
          const chain = yield this.switchChain(chainId);
          id = chain.id;
          unsupported = this.isChainUnsupported(id);
        }
        if (this.options.shimDisconnect)
          (_a = this.storage) == null ? void 0 : _a.setItem(this.shimDisconnectKey, true);
        return { account, chain: { id, unsupported }, provider };
      } catch (error) {
        if (this.isUserRejectedRequestError(error))
          throw new UserRejectedRequestError(error);
        if (error.code === -32002)
          throw new ResourceUnavailableRpcError(error);
        throw error;
      }
    });
  }
  getAccount() {
    return __async(this, null, function* () {
      const provider = yield this.getProvider();
      if (!provider)
        throw new ConnectorNotFoundError();
      const accounts = yield provider.request({
        method: "eth_requestAccounts"
      });
      let account = accounts[0];
      if (typeof account === "string" && !account.startsWith("0x")) {
        account = `0x${account}`;
      }
      return getAddress(account);
    });
  }
  switchChain(chainId) {
    return __async(this, null, function* () {
      const provider = yield this.getProvider();
      if (!provider)
        throw new ConnectorNotFoundError();
      if (mappingNetwork[chainId]) {
        try {
          yield provider.request({
            method: "wallet_switchEthereumChain",
            params: [{
              chainId: `0x${chainId.toString(16)}`
            }]
          });
          return this.chains.find((x) => x.id === chainId);
        } catch (switchError) {
          console.error("switchError", switchError, chainId, `0x${chainId.toString(16)}`);
          if (switchError.code === 4902) {
            try {
              yield provider.request({
                method: "wallet_addEthereumChain",
                nativeCurrency: {
                  name: "MNT",
                  symbol: "MNT",
                  decimals: 18
                },
                params: [
                  {
                    chainId: `0x${chainId.toString(16)}`,
                    chainName: mappingNetwork[chainId].name,
                    rpcUrls: [mappingNetwork[chainId].rpcUrl]
                  }
                ]
              });
              return this.chains.find((x) => x.id === chainId);
            } catch (addError) {
              console.error("addError", addError, chainId, `0x${chainId.toString(16)}`);
              throw new UserRejectedRequestError(addError);
            }
          }
        }
      }
      throw new SwitchChainNotSupportedError({ connector: this });
    });
  }
  getProvider() {
    return __async(this, null, function* () {
      return getBitgetWalletProvider();
    });
  }
};

export { BitgetWalletConnector, getBitgetWalletProvider };
